import React, { Component } from 'react'
import { Box, BoxProps, Button, ButtonProps, styled, Tooltip, Typography, TypographyProps } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { mapGlobalModalContext } from '../api-context'
import { Breadcrumbs, IBreadcrumbConfig } from '../components'

export interface ISectionSlots {
  before?: React.ReactNode
  after?: React.ReactNode
}

export interface IToolbarPannelProps {
  /** @default true */
  visible?: boolean
  searchInclude?: string[]
  breadcrumbs?: IBreadcrumbConfig[]
  title?: React.ReactNode
  titleSlots?: ISectionSlots
  formCreate?: React.ReactNode
  actionSlots?: ISectionSlots
  slots?: {
    rootProps?: BoxProps
    buttonCreateProps?: ButtonProps
  }
}

class ToolbarPannel extends Component<IToolbarPannelProps> {
  render() {
    if (this.props.visible === false) return
    return (
      <Wrap {...this.props.slots?.rootProps}>
        {this.props.titleSlots?.before}
        {this.renderTitle()}
        {this.props.titleSlots?.after}
        <Box sx={{ flex: { xs: '0 0 auto', md: 1 }, width: { xs: '100%', md: 'auto' } }} />
        {this.props.actionSlots?.before}
        {this.renderButtonCreate()}
        {this.props.actionSlots?.after}
      </Wrap>
    )
  }

  renderButtonCreate = () => {
    if (!this.props.formCreate) return <></>
    return mapGlobalModalContext((context) => (
      <Tooltip title='Create new'>
        <Button
          size='small'
          onClick={() => context.show({ renderContent: () => this.props.formCreate })}
          startIcon={<AddCircleOutlineIcon fontSize='small' />}
          sx={{ fontWeight: 600 }}
          variant='contained'
          {...this.props.slots?.buttonCreateProps}
        >
          Create
        </Button>
      </Tooltip>
    ))
  }

  renderTitle = () => {
    const { title, breadcrumbs } = this.props ?? {}
    if (breadcrumbs) return <Breadcrumbs value={breadcrumbs} />
    if (typeof title === 'string') return <Title>{title}</Title>
    return <>{title}</>
  }
}

export default ToolbarPannel

// const SearchHelp = styled('ul')({
//   margin: '0 0 0 18px',
//   padding: 0,
//   li: {
//     position: 'relative'
//   },
//   'li::after': {
//     content: '"►"',
//     display: 'inline-block',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     position: 'absolute',
//     left: '-18px'
//   }
// })

const Title = styled((props: TypographyProps) => <Typography noWrap variant='subtitle1' {...props} />)({
  fontWeight: 700,
  flex: 1
})

const Wrap = styled(Box)(({ theme }) => ({
  height: 'var(--height-toolbar, 56px)',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '0 6px',
  flexWrap: 'wrap',
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    padding: '12px 0',
    alignItems: 'flex-start'
  }
}))
